import * as DateFNS from "date-fns"
import { ptBR } from "date-fns/locale"
export const startOfMonth = (
  date: Date | number | string
) => {
  try {
    let parsedDate: Date
    if (typeof date === "string") {
      parsedDate = DateFNS.parseISO(date)
    } else {
      parsedDate = new Date(date)
    }
    const validDate = !isNaN(parsedDate.getTime())
    if (!validDate) return ""
    return DateFNS.formatDate(
      DateFNS.startOfMonth(parsedDate),
      "yyyy-MM-dd",
      {
        locale: ptBR,
      }
    )
  } catch {
    return ""
  }
}
export const eachDayOfInterval = ({
  start,
  end,
}: {
  start: string | Date
  end: string | Date
}): Date[] => {
  try {
    const parsedStart =
      typeof start === "string"
        ? DateFNS.parseISO(start)
        : start
    const parsedEnd =
      typeof end === "string" ? DateFNS.parseISO(end) : end
    if (
      isNaN(parsedStart.getTime()) ||
      isNaN(parsedEnd.getTime())
    )
      return []
    return DateFNS.eachDayOfInterval({
      start: parsedStart,
      end: parsedEnd,
    })
  } catch {
    return []
  }
}
export const endOfMonth = (
  date: Date | number | string
): string => {
  try {
    let parsedDate: Date
    if (typeof date === "string") {
      parsedDate = DateFNS.parseISO(date)
    } else {
      parsedDate = new Date(date)
    }
    const validDate = !isNaN(parsedDate.getTime())
    if (!validDate) return ""
    return DateFNS.formatDate(
      DateFNS.endOfMonth(parsedDate),
      "yyyy-MM-dd",
      {
        locale: ptBR,
      }
    )
  } catch {
    return ""
  }
}
export const currentDate = (
  formatPattern = "yyyy-MM-dd"
) => {
  return DateFNS.format(new Date(), formatPattern, {
    locale: ptBR,
  })
}
export const addDays = (days: number) => {
  try {
    const date = DateFNS.addDays(new Date(), days)
    return DateFNS.format(date, "yyyy-MM-dd")
  } catch {
    return ""
  }
}
export const subDays = (days: number) => {
  try {
    const date = DateFNS.subDays(new Date(), days)
    return DateFNS.format(date, "yyyy-MM-dd")
  } catch {
    return ""
  }
}
export const formatDate = (
  date?: string | Date | undefined,
  pattern = "yyyy-MM-dd"
) => {
  try {
    const parsed = safeParse(date!)
    return DateFNS.format(parsed, pattern, { locale: ptBR })
  } catch {
    return ""
  }
}
export const formatDateTime = (
  date: string | number | Date,
  pattern = "dd/MM/yyyy HH:mm:ss"
) => {
  try {
    const parsed =
      typeof date === "string" ? safeParse(date) : date
    return DateFNS.format(parsed, pattern, { locale: ptBR })
  } catch {
    return ""
  }
}
export const format = (
  value?: string,
  formatPattern = "yyyy-MM-dd"
) => {
  try {
    const parsed = safeParse(value!)
    return DateFNS.format(parsed, formatPattern, {
      locale: ptBR,
    })
  } catch {
    return ""
  }
}
export const formatToISO = (value: string) => {
  try {
    const date = DateFNS.parseISO(value)
    return DateFNS.formatISO(date)
  } catch {
    return ""
  }
}
export const stringToDate = (value: string) => {
  try {
    return DateFNS.toDate(DateFNS.addHours(value, 3))
  } catch {
    return new Date()
  }
}
export const safeParse = (date: string | Date) => {
  try {
    if (typeof date === "string") {
      if (date.includes("T")) {
        return DateFNS.parseISO(date)
      }
      if (date.includes(" ") && date.includes(":")) {
        return DateFNS.parseISO(date.replace(" ", "T"))
      }
      return new Date(date + "T12:00")
    }
    return date
  } catch (error) {
    console.error("Error parsing date:", error)
    return ""
  }
}
